import { ReactNode } from 'react';
import './Fpv.css'
import { Button } from 'react-bootstrap'

export interface FpvModeButtonProps {
    onClick: () => void;
}

function FpvModeButton({ onClick }: FpvModeButtonProps): ReactNode {
    return (
        <div className='navigation-elem'>
            <Button style={{ width: 'inherit' }} onClick={onClick}>FPV Режим</Button>
        </div>
    )
}

export default FpvModeButton;